import TextWidget from "QuorumGrassroots/widgets/Text/components/index"

export default TextWidget
